/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export interface StudentLevelStats {
  level: number;
  /** Tasks not yet started */
  tasksNew?: number;
  /** Tasks in progress */
  tasksDraft?: number;
  /** Tasks completed */
  tasksDone?: number;
  /** Sum of task timespans for this level */
  totalTaskTimespansHours?: number;
}
